/** Base UI language code (en | nl | de | fr). */
export function languageBaseCode(lng) {
  const c = String(lng || "en").split("-")[0].toLowerCase();
  if (c === "nl" || c === "de" || c === "fr") return c;
  return "en";
}

export function languageFlagSrc(lng) {
  const c = languageBaseCode(lng);
  if (c === "nl") return "/head/foot2-1.svg";
  if (c === "de") return "/head/foot2-de.svg";
  if (c === "fr") return "/head/foot2-fr.svg";
  return "/head/foot2-2.svg";
}

/** i18n key for the current language label in the footer/header. */
export function languageLabelKey(lng) {
  const c = languageBaseCode(lng);
  if (c === "nl") return "footer.langDutch";
  if (c === "de") return "footer.langGerman";
  if (c === "fr") return "footer.langFrench";
  return "footer.langEnglish";
}
